const wrapper = {
    textAlign: 'center',
    width: 'auto',
    margin: 'auto',
    paddingX: '30px',
    paddingTop: {base: '15px', md: '40px'},
    paddingBottom: {base: '20px', md: '40px'}
}

const eyebrow = {
    fontSize: {base: '24px', md: '36px'},
    letterSpacing: {base: '0.12px', md: '0.18px'},
    fontWeight: '400',
    lineHeight: 'normal'
}

const title = {
    fontSize: {base: '72px', xl: '128px'},
    letterSpacing: {base: '0.36px', xl: '0.64px'},
    lineHeight: {base: '90px', xl: '90px'},
    fontWeight: '400'
}

const titleInner = {
    fontSize: {base: '48px', md: '64px'},
    letterSpacing: {base: '0.24px', md: '0.32px'},
    lineHeight: 'normal'
}

const subTitle = {
    fontSize: {base: '24px', md: '36px'},
    letterSpacing: {base: '0.12px', md: '0.18px'},
    fontWeight: '400',
    lineHeight: 'normal'
}

export default {
    baseStyles: {
        wrapper: {
            ...wrapper,
            gap: {base: 0, md: '35px'}
        },
        eyebrow: {},
        title: {},
        subTitle: {},
        titleInner: {}
    },
    variants: {
        heroPercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '35px'}
            },
            eyebrow: {
                ...eyebrow
            },
            title: {
                ...title
            },
            subTitle: {
                ...subTitle
            }
        },
        skinnyPercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '25px'}
            },
            eyebrow: {
                ...eyebrow
            },
            title: {
                ...title
            },
            subTitle: {
                ...subTitle
            }
        },
        heroSidePercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '35px'}
            },
            eyebrow: {
                fontSize: {base: '24px', md: '24px', xl: '36px'},
                letterSpacing: {base: '0.12px', md: '0.12px', xl: '0.18px'},
                fontWeight: '400',
                lineHeight: 'normal'
            },
            title: {
                fontSize: {base: '72px', md: '60px', lg: '72px', 'xl-large': '128px'},
                letterSpacing: {base: '0.36px', md: '0.32px', lg: '0.36px', 'xl-large': '0.64px'},
                lineHeight: {base: '72px', md: '60px', lg: '72px', 'xl-large': '90px'},
                fontWeight: '400'
            },
            subTitle: {
                fontSize: {base: '24px', md: '24px', xl: '36px'},
                letterSpacing: {base: '0.12px', md: '0.12px', xl: '0.18px'},
                fontWeight: '400',
                lineHeight: 'normal'
            }
        },
        skinnySidePercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '25px'}
            },
            eyebrow: {
                fontSize: {base: '24px', md: '24px', xl: '36px'},
                letterSpacing: {base: '0.12px', md: '0.12px', xl: '0.18px'},
                fontWeight: '400',
                lineHeight: 'normal'
            },
            title: {
                fontSize: {base: '72px', md: '60px', lg: '72px', 'xl-large': '128px'},
                letterSpacing: {base: '0.36px', md: '0.32px', lg: '0.36px', 'xl-large': '0.64px'},
                lineHeight: {base: '72px', md: '60px', lg: '72px', 'xl-large': '90px'},
                fontWeight: '400'
            },
            subTitle: {
                fontSize: {base: '24px', md: '24px', xl: '36px'},
                letterSpacing: {base: '0.12px', md: '0.12px', xl: '0.18px'},
                fontWeight: '400',
                lineHeight: 'normal'
            }
        },
        promoGridTwoItemsPercentOff: {
            wrapper: {
                ...wrapper,
                paddingX: {base: '30px', xl: '60px'},
                paddingTop: {base: '15px', xl: '20px'},
                paddingBottom: {base: '20px', xl: '20px'},
                gap: {base: '0', xl: '10px', '2xl': '25px'}
            },
            eyebrow: {
                fontSize: {base: '24px', '2xl': '36px'},
                letterSpacing: {base: '0.12px', '2xl': '0.18px'},
                fontWeight: '400',
                lineHeight: 'normal'
            },
            title: {
                fontSize: {base: '72px', '2xl': '128px'},
                letterSpacing: {base: '0.36px', '2xl': '0.64px'},
                lineHeight: {base: '72px', '2xl': '90px'},
                fontWeight: '400'
            },
            subTitle: {
                fontSize: {base: '24px', '2xl': '36px'},
                letterSpacing: {base: '0.12px', '2xl': '0.18px'},
                fontWeight: '400',
                lineHeight: 'normal'
            }
        },
        promoGridFourItemsPercentOff: {
            wrapper: {
                ...wrapper,
                paddingX: {base: '30px', xl: '60px'},
                paddingTop: {base: '15px', xl: '20px'},
                paddingBottom: {base: '20px', xl: '20px'},
                gap: {base: '0', md: '0'}
            },
            eyebrow: {
                fontSize: {base: '24px', md: '24px'},
                letterSpacing: {base: '0.12px', md: '0.12px'},
                fontWeight: '700',
                lineHeight: 'normal'
            },
            title: {
                fontSize: {base: '60px', xs: '72px'},
                letterSpacing: {base: '0.36px', md: '0.36px'},
                lineHeight: {base: '64px', xs: '90px'},
                fontWeight: '400'
            },
            subTitle: {
                fontSize: {base: '24px', md: '24px'},
                letterSpacing: {base: '0.12px', md: '0.12px'},
                fontWeight: '700',
                lineHeight: 'normal'
            }
        },

        heroUpToPercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '13px'}
            },
            title: {
                fontSize: {base: '64px', xl: '128px'},
                letterSpacing: {base: '0.36px', xl: '0.64px'},
                lineHeight: {base: '64px', xl: '90px'},
                fontWeight: '400'
            },
            titleInner: {
                fontFamily: 'cormorant',
                fontSize: {base: '24px', xl: '48px'},
                letterSpacing: {base: '0.24px', xl: '0.24px'},
                lineHeight: 'normal',
                fontWeight: '400'
            },
            subTitle: {
                ...subTitle
            }
        },
        skinnyUpToPercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '13px'}
            },
            title: {
                fontSize: {base: '64px', xl: '128px'},
                letterSpacing: {base: '0.36px', xl: '0.64px'},
                lineHeight: {base: '64px', xl: '90px'},
                fontWeight: '400'
            },
            titleInner: {
                fontFamily: 'cormorant',
                fontSize: {base: '24px', xl: '48px'},
                letterSpacing: {base: '0.24px', xl: '0.24px'},
                lineHeight: 'normal',
                fontWeight: '400'
            },
            subTitle: {
                ...subTitle
            }
        },
        heroSideUpToPercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '13px'}
            },
            title: {
                fontSize: {base: '64px', md: '48px', lg: '64px', 'xl-large': '128px'},
                letterSpacing: {base: '0.36px', md: '0.24px', lg: '0.36px', 'xl-large': '0.64px'},
                lineHeight: {base: '64px', md: '48px', lg: '64px', 'xl-large': '90px'},
                fontWeight: '400'
            },
            titleInner: {
                fontFamily: 'cormorant',
                fontSize: {base: '24px', md: '20px', lg: '24px', 'xl-large': '48px'},
                letterSpacing: {base: '0.24px', md: '0.22px', lg: '0.24px', 'xl-large': '0.24px'},
                lineHeight: 'normal',
                fontWeight: '400'
            },
            subTitle: {
                fontSize: {base: '24px', md: '24px', 'xl-large': '36px'},
                letterSpacing: {base: '0.12px', md: '0.12px', 'xl-large': '0.18px'},
                fontWeight: '400',
                lineHeight: 'normal'
            }
        },
        skinnySideUpToPercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '13px'}
            },
            title: {
                fontSize: {base: '64px', md: '48px', lg: '64px', 'xl-large': '128px'},
                letterSpacing: {base: '0.36px', md: '0.24px', lg: '0.36px', 'xl-large': '0.64px'},
                lineHeight: {base: '64px', md: '48px', lg: '64px', 'xl-large': '90px'},
                fontWeight: '400'
            },
            titleInner: {
                fontFamily: 'cormorant',
                fontSize: {base: '24px', md: '20px', lg: '24px', 'xl-large': '48px'},
                letterSpacing: {base: '0.24px', md: '0.22px', lg: '0.24px', 'xl-large': '0.24px'},
                lineHeight: 'normal',
                fontWeight: '400'
            },
            subTitle: {
                fontSize: {base: '24px', md: '24px', 'xl-large': '36px'},
                letterSpacing: {base: '0.12px', md: '0.12px', 'xl-large': '0.18px'},
                fontWeight: '400',
                lineHeight: 'normal'
            }
        },
        promoGridTwoItemsUpToPercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '13px'}
            },
            title: {
                fontSize: {base: '72px', '2xl': '128px'},
                letterSpacing: {base: '0.36px', '2xl': '0.64px'},
                lineHeight: {base: '72px', '2xl': '90px'},
                fontWeight: '400'
            },
            titleInner: {
                fontFamily: 'cormorant',
                fontSize: {base: '48px', lg: '48px'},
                letterSpacing: {base: '0.24px', lg: '0.24px'},
                lineHeight: 'normal',
                fontWeight: '400'
            },
            subTitle: {
                ...subTitle
            }
        },
        promoGridFourItemsUpToPercentOff: {
            wrapper: {
                ...wrapper,
                gap: {base: 0, md: '13px'}
            },
            title: {
                fontSize: {base: '52px', xs: '64px', lg: '72px'},
                letterSpacing: {base: '0.36px', lg: '0.36px'},
                lineHeight: {base: '52px', xs: '64px', lg: '64px'},
                fontWeight: '400'
            },
            titleInner: {
                fontFamily: 'cormorant',
                fontSize: {base: '24px', lg: '24px'},
                letterSpacing: {base: '0.12px', lg: '0.12px'},
                lineHeight: 'normal',
                fontWeight: '400'
            },
            subTitle: {
                fontSize: {base: '24px', md: '24px'},
                letterSpacing: {base: '0.12px', md: '0.12px'},
                fontWeight: '700',
                lineHeight: 'normal'
            }
        },

        heroBuyXForY: {
            wrapper: {
                ...wrapper,
                gap: {base: '5px', md: '10px'}
            },
            eyebrow: {
                ...eyebrow
            },
            title: {
                ...title
            },
            titleInner: {
                ...titleInner,
                lineHeight: 'inherit'
            },
            subTitle: {
                ...subTitle
            }
        },
        skinnyBuyXForY: {
            wrapper: {
                ...wrapper,
                gap: {base: '5px', md: '10px'}
            },
            eyebrow: {
                ...eyebrow
            },
            title: {
                ...title
            },
            titleInner: {
                ...titleInner,
                lineHeight: 'inherit'
            },
            subTitle: {
                ...subTitle
            }
        },
        heroSideBuyXForY: {
            wrapper: {
                ...wrapper,
                gap: {base: '5px', md: '10px'}
            },
            eyebrow: {
                ...eyebrow
            },
            title: {
                fontSize: {base: '72px', md: '72px', 'xl-large': '128px'},
                letterSpacing: {base: '0.36px', md: '0.36px', 'xl-large': '0.64px'},
                lineHeight: {base: '80px', md: '80px', 'xl-large': '90px'},
                fontWeight: '400'
            },
            titleInner: {
                fontSize: {base: '48px', md: '48px', 'xl-large': '64px'},
                letterSpacing: {base: '0.24px', md: '0.24px', 'xl-large': '0.24px'},
                fontWeight: '400',
                lineHeight: 'inherit'
            },
            subTitle: {
                ...subTitle
            }
        },
        skinnySideBuyXForY: {
            wrapper: {
                ...wrapper,
                gap: {base: '5px', md: '10px'}
            },
            eyebrow: {
                ...eyebrow
            },
            title: {
                fontSize: {base: '72px', md: '72px', 'xl-large': '128px'},
                letterSpacing: {base: '0.36px', md: '0.36px', 'xl-large': '0.64px'},
                lineHeight: {base: '80px', md: '80px', 'xl-large': '90px'},
                fontWeight: '400'
            },
            titleInner: {
                fontSize: {base: '48px', md: '48px', 'xl-large': '64px'},
                letterSpacing: {base: '0.24px', md: '0.24px', 'xl-large': '0.24px'},
                fontWeight: '400',
                lineHeight: 'inherit'
            },
            subTitle: {
                ...subTitle
            }
        },
        promoGridTwoItemsBuyXForY: {
            wrapper: {
                ...wrapper,
                gap: {base: '5px', xl: '10px'}
            },
            eyebrow: {
                ...eyebrow
            },
            title: {
                fontSize: {base: '72px', '2xl': '128px'},
                letterSpacing: {base: '0.36px', '2xl': '0.64px'},
                lineHeight: {base: '72px', '2xl': '90px'},
                fontWeight: '400'
            },
            titleInner: {
                ...titleInner,
                lineHeight: 'inherit'
            },
            subTitle: {
                ...subTitle
            }
        },
        promoGridFourItemsBuyXForY: {
            wrapper: {
                ...wrapper,
                gap: {base: '5px', md: '10px'}
            },
            eyebrow: {
                fontSize: {base: '24px', md: '24px'},
                letterSpacing: {base: '0.12px', md: '0.12px'},
                fontWeight: '400',
                lineHeight: 'normal'
            },
            title: {
                fontSize: {base: '60px', xs: '72px'},
                letterSpacing: {base: '0.36px', md: '0.36px'},
                lineHeight: {base: '64px', xs: '80px'},
                fontWeight: '400'
            },
            titleInner: {
                fontSize: {base: '48px', md: '48px'},
                letterSpacing: {base: '0.24px', md: '0.24px'},
                fontWeight: '400',
                lineHeight: 'inherit'
            },
            subTitle: {
                fontSize: {base: '24px', md: '24px'},
                letterSpacing: {base: '0.12px', md: '0.12px'},
                fontWeight: '400',
                lineHeight: 'normal'
            }
        }
    },
    parts: ['wrapper', 'eyebrow', 'title', 'subTitle', 'titleInner'],
    defaultProps: {
        variant: 'heroPercentOff'
    }
}
